<div class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th>{{'dashboard.datatables.byPartitions.partitions.shortLabel' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let partition of partitions | partitionsFlagFilter: flagType.modified">
                    <tr class="deep-0 main-row">
                        <td>{{partition.partitionDetails.text?.fullLabel}}</td>
                    </tr>
                    <tr class="deep-0">
                        <td>{{ 'dashboard.datatables.edited.indice.fullLabel' | translate }}</td>
                    </tr>
                    <tr class="deep-0" *ngIf="!isMJP">
                        <td>{{ 'dashboard.datatables.edited.additional.fullLabel' | translate }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let kpiYear of kpisByYear">{{ kpiYear.year }}</th>
                    <th *ngIf="!isMJP">
                        {{ 'dashboard.datatables.parameters.projectionRate.shortLabel' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let partition of partitions | partitionsFlagFilter: flagType.modified">
                    <tr class="deep-0 main-row">
                        <td *ngFor="let year of partition.simulationValues.years" [ngClass]="{executed: !year.isEstimated}">
                            <span class="amount">{{ year.amount | formatAmount }}</span>
                        </td>
                        <td *ngIf="!isMJP"></td>
                    </tr>
                    <tr class="deep-0">
                        <td *ngFor="let year of partition.simulationValues.years" [ngClass]="{executed: !year.isEstimated}">
                            <ng-container *ngIf="year.isEstimated">
                                <span class="percent" *ngIf="year.mode === indiceModeType.ac">
                                    {{ year.indice }}
                                </span>
                                <span class="percent" *ngIf="year.mode === indiceModeType.percent && !isMJP">
                                    {{ year.indice | formatPercent }}
                                </span>
                                <span class="percent" *ngIf="year.mode === indiceModeType.percent && isMJP">
                                    {{ (year.isRateNeutralized ? year.indice : (partition.projectionRate.rate + year.indice)) | formatPercent }}
                                </span>
                            </ng-container>
                        </td>
                        <td *ngIf="!isMJP">
                            {{ partition.projectionRate.rate | formatPercent }}
                        </td>
                    </tr>
                    <tr class="deep-0" *ngIf="!isMJP">
                        <td *ngFor="let year of partition.simulationValues.years" [ngClass]="{executed: !year.isEstimated}">
                            <span class="amount" *ngIf="year.isEstimated">
                                {{ year.additionalAmount | formatAmount }}
                            </span>
                        </td>
                        <td></td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </section>
</div>
